import { BvTableFieldArray } from 'bootstrap-vue';
import Vue from 'vue';

const SENSOR_TYPE_STRAIN = 'strain';

interface FeedTankRow {
	sensorType?: string | null;
	nominalVolume?: number | null;
	nominalWeight?: number | null;
}

function formatCapacity(row: FeedTankRow): string {
	const tonnes = (Vue.filter('tonnes') as (v: number | null | undefined) => string)(row.nominalWeight);
	if (row.sensorType === SENSOR_TYPE_STRAIN) {
		return tonnes ?? '';
	}
	return `${row.nominalVolume ?? ''} L | ${tonnes}`;
}

export const feedTankOverviewFields: BvTableFieldArray = [
	{ key: 'id', label: 'Id' },
	{ key: 'name', label: 'Name' },
	{
		key: 'sensorType',
		label: 'Sensor Type',
		formatter: (sensorType: string | null) => Vue.filter('titleCase')(sensorType) ?? 'No sensor type',
	},
	{
		key: 'capacity',
		label: 'Capacity',
		formatter: (_value: unknown, _key: string, item: FeedTankRow) => formatCapacity(item),
	},
	{
		key: 'status',
		label: 'Status',
		formatter: (status: string | null) => Vue.filter('titleCase')(status) ?? 'No status',
	},
];
